import { Outlet, createFileRoute } from '@tanstack/react-router'

/**
 * Layout route for the Cases section.
 *
 * `/cases` owns child routes (`cases/$caseId/view`), which makes this a **parent**
 * route — and a parent only renders its children through `<Outlet />`. Putting
 * `CasesPage` here directly is the bug it looks like it isn't: the child route
 * matches, the URL changes, and the list keeps rendering because nothing ever
 * gives the child somewhere to go. The list therefore lives in `cases/index.tsx`.
 */
export const Route = createFileRoute('/_auth/cases')({
  component: Outlet,
})
